module.exports = __webpack_public_path__ + "static/gmail-2dc802d482246eaa78fec16a445dfcc3.png";